










import { Component, Vue } from "vue-property-decorator";
import { IRoute } from "@/@types/routes/routes";
import { IUser } from "@/@types/admin/user/user";
import { AccessToken } from "@/services/accessDecoder";
import { auth } from "@/config/host.config";

@Component({ name: "Hotel" })
export default class Hotel extends Vue {
  routes: Array<string> = [];
  route = "";

  managers: Array<IUser> = [];
  master = AccessToken.id;

  createRoutes(): void {
    const routes: Array<IRoute> = this.$store.getters.ROUTER_STATE;
    const route = routes.find((el: IRoute) => el.name == this.$options.name);
    if (!routes.length || !route) this.routes.push("StaffPage");
    else route.children.forEach((r) => this.routes.push(r));

    this.route = this.$route.name ? this.$route.name : this.routes[0];
  }

  changeRoute(route: string): void {
    this.route = route;
    this.$router.push({ name: route });
  }

  async getPadawans(): Promise<void> {
    if (!this.master) return;
    const url = auth.getUser;
    const params = { master: this.master };
    try {
      const resUser = await this.$axios.get(url, { params });
      if (resUser.status === 200) this.managers = resUser.data;
    } catch (error) {
      console.log(error);
    }
  }

  mounted(): void {
    this.createRoutes();
    this.getPadawans();
  }
}
